exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "::-webkit-input-placeholder{overflow-y:visible}::-moz-placeholder{overflow-y:visible}:-ms-input-placeholder{overflow-y:visible}:-moz-placeholder{overflow-y:visible}\n", ""]);

